var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import styled from "styled-components";
import { GalleryIcon, GridIcon } from "../../../assets/icons/icons";
import colors from "../../../designSystem/colors";
import theme from "../../../designSystem/theme";
var Button = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background: ", "0A;\n  height: 45px;\n  width: 45px;\n  border-radius: ", ";\n\n  &:hover {\n    background: ", "14;\n  }\n"], ["\n  background: ", "0A;\n  height: 45px;\n  width: 45px;\n  border-radius: ", ";\n\n  &:hover {\n    background: ", "14;\n  }\n"])), colors.primaryText, theme.border.radius, colors.primaryText);
var SwitchViewButton = function (_a) {
    var view = _a.view, setView = _a.setView;
    var viewIcon = useMemo(function () {
        switch (view) {
            case "gallery":
                return _jsx(GridIcon, {}, void 0);
            case "grid":
                return _jsx(GalleryIcon, {}, void 0);
        }
    }, [view]);
    return (_jsx(Button, __assign({ role: "button", className: "d-flex align-items-center justify-content-center", onClick: function () { return setView(function (v) { return (v === "grid" ? "gallery" : "grid"); }); } }, { children: viewIcon }), void 0));
};
export default SwitchViewButton;
var templateObject_1;
//# sourceMappingURL=SwitchViewButton.js.map